import { render, staticRenderFns } from "./myorderinfo.vue?vue&type=template&id=5de82fda&scoped=true&"
import script from "./myorderinfo.vue?vue&type=script&lang=js&"
export * from "./myorderinfo.vue?vue&type=script&lang=js&"
import style0 from "./myorderinfo.vue?vue&type=style&index=0&id=5de82fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de82fda",
  null
  
)

export default component.exports